module.exports = __webpack_public_path__ + "static/select-1c35b51c3675d6749ae954063fc3917f.svg";